import React, { FC, memo, useState } from 'react'
import s from './OwnerRestCardDescription.module.sass'
import { API } from '@shared/api'
import { addTemporaryNotice } from '@widgets/Common/Notices'
import { useAppDispatch, useAppSelector } from '@app/model/store'
import { OwnerPersonalPageProps } from '@pages/OwnerPersonalPage/OwnerPersonalPage'
import { OwnerRestInfoTextarea } from '@pages/OwnerPersonalPage/ui/components/OwnerRestInfoTextarea'

const OwnerRestCardDescription: FC<OwnerPersonalPageProps> = (props) => {
  const dispatch = useAppDispatch()
  // @ts-ignore
  const descriptionState = useAppSelector((store) => store.pages.owner_personal.posts?.description)
  const propsOwnerDescr = descriptionState || props?.data?.description?.description?.owner || ''

  const [isDescrLoad, setIsDescrLoad] = useState(false)
  const [isDescrDone, setIsDescrDone] = useState(false)
  const [ownerDescrTextarea, setOwnerDescrTextarea] = useState(propsOwnerDescr)
  const [isOwnerDescrValid, setIsOwnerDescrValid] = useState(true)
  const aboutMaxLength = 4000
  const ownerAboutPlaceholder = 'Расскажите о главных особенностях вашего ресторана, команде, расположении'
  const isSubmitInfoDisabled = !isOwnerDescrValid

  const removeTripleLineBreaks = (value: any): string => {
    let output = value || ''
    const hasTripleLineBreaks = output.indexOf('\n\n\n') >= 0
    output = hasTripleLineBreaks ? output.replace('\n\n\n', '\n\n') : output
    return output
  }

  const trimVal = (thisVal: string): string => thisVal?.trim() || ''

  const handleOwnerDescr = {
    onChange: (ev: React.ChangeEvent<HTMLTextAreaElement>) => {
      let newValue = ev?.target?.value ? ev.target.value : ''
      newValue = removeTripleLineBreaks(newValue)

      const isMaxChars = newValue.length > aboutMaxLength
      const isEmptyData = newValue === ''
      setIsOwnerDescrValid(isEmptyData || !isMaxChars ? true : false)
      setOwnerDescrTextarea(newValue)
    },
    onBlur: (ev: React.ChangeEvent<HTMLTextAreaElement>) => {
      let newValue = ev?.target?.value ? ev.target.value : ''
      newValue = trimVal(newValue)

      setIsOwnerDescrValid(newValue.length > aboutMaxLength ? false : true)
      setOwnerDescrTextarea(newValue)
    },
    onFocus: (ev: React.ChangeEvent<HTMLTextAreaElement>) => {
      // empty
    },
  }

  const handleSubmitAboutText = async (ev: React.SyntheticEvent) => {
    setIsDescrLoad(true)

    const params = {
      rid: props.data.id,
      restaurant: props.data.id,
      body: { description: ownerDescrTextarea },
    }

    // запрос на изменение текста о ресторане
    API.r_info(params)
      .then((response) => {
        if (response?.data?.description) {
          setOwnerDescrTextarea(response.data.description)
        }
        setIsDescrDone(true)
      })
      .catch((error) => {
        dispatch(addTemporaryNotice({ markup: 'Ошибка обновления описания' }))
      })
      .finally(() => {
        setIsDescrLoad(false)
      })
  }

  return (
    <OwnerRestInfoTextarea
      name={'rest-text-about'}
      resize={true}
      onChange={handleOwnerDescr.onChange}
      onBlur={handleOwnerDescr.onBlur}
      onFocus={handleOwnerDescr.onFocus}
      value={ownerDescrTextarea}
      isValid={isOwnerDescrValid}
      isEmpty={ownerDescrTextarea?.length <= 0}
      isDescrLoad={isDescrLoad}
      isDescrDone={isDescrDone}
      placeholder={ownerAboutPlaceholder}
      isSubmitInfoDisabled={isSubmitInfoDisabled}
      handleSubmitAboutText={handleSubmitAboutText}
      ownerDescrTextarea={ownerDescrTextarea}
    />
  )
}

export default memo(OwnerRestCardDescription)
